var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAllDone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 4.66668L11.0601 3.72668L6.83344 7.95335L7.77344 8.89335L12.0001 4.66668ZM14.8268 3.72668L7.77344 10.78L4.98677 8.00002L4.04677 8.94002L7.77344 12.6667L15.7734 4.66668L14.8268 3.72668ZM0.273438 8.94002L4.0001 12.6667L4.9401 11.7267L1.2201 8.00002L0.273438 8.94002Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllDone);
export default __webpack_public_path__ + "static/media/all-done.3953df67f226cb2f11fa8e77d4b5f0b2.svg";
export { ForwardRef as ReactComponent };